export default "__VITE_ASSET__XXyNBhxM__"